import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Footer — quiet bottom rail.
 *
 * Two information layers:
 *   1. Trust line — what settles bets, that we are on-chain, and the
 *      "one bet per market" invariant. This is the page-level brand
 *      signature; it states the platform's commitments in 1 sentence.
 *   2. Copyright + legal links.
 *
 * Polished from the previous "copyright · privacy · terms" one-liner by
 * (a) adding the trust line as primary, (b) keeping legal small and to
 * the right.
 */
export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border-card bg-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          {/* Trust line — first read */}
          <p className="text-[12px] text-text-light leading-relaxed">
            {t("footer.trustLine")}
          </p>

          {/* Copyright + legal */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[12px] text-text-muted">
            <span className="font-mono tabular-nums">
              {t("footer.copyright", { year })}
            </span>
            <Link
              to="/privacy"
              className="hover:text-text-dark transition-colors"
            >
              {t("footer.privacy")}
            </Link>
            <Link
              to="/terms"
              className="hover:text-text-dark transition-colors"
            >
              {t("footer.terms")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
